import { createAction, props } from '@ngrx/store';

export const PlayerReady = createAction('[Player] is ready');
export const PlayerPlaying = createAction('[Player] is playing', props<{url: string, message: string}>());
export const PlayerStopped = createAction('[Player] has stopped');

export const PlayRequest = createAction('[Player] play request', props<{url: string, PiP: boolean}>());
export const StopRequest = createAction('[Player] stop request');

